import { useId } from "react";

/**
 * The field's own `id` — what the label's `htmlFor` points at and what every message id derives
 * from. `name` is preferred over the generated fallback because it is stable and readable in the
 * DOM and in tests; it is not itself an `id`, which is why it is copied into one rather than used
 * in its place.
 */
export const useFieldId = (id?: string, name?: string) => {
  const generatedId = useId();

  return id ?? name ?? generatedId;
};
